import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-container">
            <div className="privacy-content">
                <h1>Privacy Policy for Number Paint: Coloring App</h1>
                <h2>1. Introduction</h2>
                <p>
                    Welcome to Number Paint: Coloring App. We are committed to safeguarding your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and protect your data when you use our app, with special considerations for users under 13 years of age.
                </p>
                <h2>2. Information We Collect</h2>
                <p>
                    <b>Birthdate Information:</b> We collect your birthdate to determine your age and enforce age-based feature restrictions in compliance with COPPA. This information is used solely for age verification purposes.
                </p>
                <p>
                    <b>Personal Information:</b> We collect personal information such as your name and email address when you create an account. For users under 13, we obtain verifiable parental consent before collecting this information, in compliance with COPPA and GDPR regulations.
                </p>
                <p>
                    <b>Images:</b> When you upload images or use the camera feature to create paint-by-number images, these images are processed on our secure servers and stored in the cloud. For users under 13, these features are disabled to comply with child privacy regulations.
                </p>
                <p>
                    <b>Usage Data:</b> We may collect non-personal information about your interactions with the app, such as feature usage frequency, to improve user experience. This data is collected in compliance with applicable laws and does not include personal identifiers.
                </p>
                <h2>3. How We Use Your Information</h2>
                <p>
                    <b>Age Verification:</b> Birthdate information is used to verify your age and apply appropriate feature restrictions to comply with child privacy laws.
                </p>
                <p>
                    <b>Account Management:</b> Personal information is used to manage your account and provide personalized experiences. For users under 13, this is done with parental consent.
                </p>
                <p>
                    <b>Image Processing:</b> For users aged 13 and above, images you upload or capture are used solely to generate paint-by-number templates and are stored securely in the cloud.
                </p>
                <p>
                    <b>App Improvement:</b> Usage data helps us understand user preferences and enhance app functionality.
                </p>
                <h2>4. Data Sharing and Disclosure</h2>
                <p>
                    We do not share, sell, or disclose your personal information to third parties, except as required by law or with parental consent for users under 13.
                </p>
                <h2>5. Data Security</h2>
                <p>
                    We implement industry-standard security measures to protect your data from unauthorized access or disclosure.
                </p>
                <h2>6. Children's Privacy</h2>
                <p>
                    <b>Compliance with COPPA and GDPR:</b> We comply with the Children's Online Privacy Protection Act (COPPA) and the General Data Protection Regulation (GDPR) concerning data protection for children.
                </p>
                <p>
                    <b>Parental Consent:</b> For users under 13, we obtain verifiable parental consent before collecting personal information. Parents have the right to review, delete, or refuse further collection of their child's personal information by contacting us at <a href="mailto:numberpaintcoloringgame@gmail.com">numberpaintcoloringgame@gmail.com</a>.
                </p>
                <p>
                    <b>Feature Restrictions:</b> To protect the privacy of users under 13, certain features such as the camera and image upload functionalities are disabled for these users.
                </p>
                <h2>7. Data Deletion Requests</h2>
                <p>
                    If you wish to request the deletion of your data, please visit our Data Deletion Request page at <a href="https://number-paint-app.vercel.app/data-deletion">data-deletion</a>.
                </p>
                <h2>8. Changes to This Privacy Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy within the app.
                </p>
                <h2>9. Contact Us</h2>
                <p>
                    If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:numberpaintcoloringgame@gmail.com">numberpaintcoloringgame@gmail.com</a>.
                </p>
                <p>
                    By using Number Paint: Coloring App, you agree to the terms outlined in this Privacy Policy.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
